import React, { useState } from 'react';
import classNames from 'classnames';

import { SvgIcon } from '@components/SvgIcon';
import { fontWeightEnum, Text, textVariantsEnum } from '@components/Text';

import styles from './Accordion.module.scss';
import { SvgIconSrc } from '../SvgIcon/SvgIcon.constants';

export const AccordionComponent = ({
  heading,
  isOpenOnStart = true,
  className,
  children,
  iconList,
  arrowLeft,
  iconsClassName,
  showDivider = false,
  contentClassName,
  headingClass,
  onOpenChange,
}) => {
  const [isOpen, setIsOpen] = useState(isOpenOnStart);
  const accordionClass = classNames(
    styles.accordion,
    { [styles.isOpen]: isOpen },
    { [styles.isClose]: !isOpen },
    className
  );

  const iconsClass = classNames(styles.iconList, iconsClassName);
  let tHeading = heading;
  if (typeof heading === 'string') {
    tHeading = (
      <Text
        variant={textVariantsEnum.Text_md}
        fontWeight={fontWeightEnum.Medium}
        color="gray-900"
      >
        {heading}
      </Text>
    );
  }
  return (
    <div className={accordionClass}>
      <div
        className={classNames(styles.headingWrapper, headingClass, {
          [styles.divider]: showDivider,
          [styles.headingWrapper_withArrowLeft]: arrowLeft,
        })}
        onClick={() => {
          setIsOpen((prev) => {
            const next = !prev;
            onOpenChange?.(next);
            return next;
          });
        }}
      >
        {tHeading}
        <div className={iconsClass}>
          <div
            className={styles.iconList}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {iconList}
          </div>
        </div>
        <SvgIcon
          src={SvgIconSrc.arrowChevron}
          size={16}
          className={styles.arrowChevron}
          rotate={isOpen ? '180' : '0'}
        />
      </div>
      <div className={classNames(styles.content, contentClassName)}>
        {children}
      </div>
    </div>
  );
};

AccordionComponent.displayName = 'Accordion';
